<template>
  <div class="pt-1">
    <div v-if="userRole!==viewerRoleName&&!forbiddenBrowser">
      <v-btn
        small
        depressed
        :disabled="!earliestLogInfo.existsLogAllServices"
        id="cutomer-add-btn"
        class="primary lighten-1 white--text"
        @click.native.stop="startDialog"
        slot="activator"
      >
        <v-icon>cloud_download</v-icon> &nbsp;
            {{$t('csv-download.button-csv-download')}}
      </v-btn>
    </div>
    <v-dialog
      v-model="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <v-form
          v-model="validated"
          ref="csvDownloadForm">
          <h4>{{$t('csv-download.start-datetime')}}</h4>
          <v-layout row>
            <v-flex xs4>
              <v-dialog
                ref="datePickerStartDialog"
                persistent
                v-model="showDatepickerStart"
                lazy
                content-class="datepicker-dialog"
                :return-value.sync="dateStart"
              >
                <v-text-field
                  slot="activator"
                  :label="$t('chart.label-date')"
                  v-model="formatDateStart"
                  prepend-icon="event"
                  readonly
                  class="datepicker-field"
                  :rules="startDateEndDateRules"
                ></v-text-field>
                <v-date-picker v-model="dateStart" :min="dateRangeMin" :max="dateRangeMax" scrollable
                  :title-date-format="date => this.formatDateCommon(date, {month: 'numeric', day: 'numeric'})"
                  :header-date-format="date => this.formatDateCommon(date, {year: 'numeric', month: 'numeric'})"
                  :month-format="date => this.formatDateCommon(date, {month: 'numeric'})"
                  :first-day-of-week="firstDayOfWeek()"
                  :locale="locale">
                  <v-spacer></v-spacer>
                  <v-btn small outline flat
                    type="button"
                    @click="showDatepickerStart = false">{{$t("btn.cancel")}}</v-btn>
                  <v-btn small outline flat
                    type="button"
                    @click="$refs.datePickerStartDialog.save(dateStart)">{{$t("btn.ok")}}</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs4>

              <v-select
                :label="$t('chart.label-time')"
                v-model="timeStart"
                :items="selectTimes"
                required
                auto
                :rules="startTimeEndTimeRules"
              ></v-select>

            </v-flex>
          </v-layout>

          <h4>{{$t('csv-download.end-datetime')}}</h4>
          <v-layout row>
            <v-flex xs4>
              <v-dialog
                ref="datePickerEndDialog"
                persistent
                v-model="showDatepickerEnd"
                lazy
                content-class="datepicker-dialog"
                :return-value.sync="dateEnd"
              >
                <v-text-field
                  slot="activator"
                  :label="$t('chart.label-date')"
                  v-model="formatDateEnd"
                  prepend-icon="event"
                  readonly
                  class="datepicker-field"
                  :rules="startDateEndDateRules"
                ></v-text-field>
                <v-date-picker v-model="dateEnd" :min="dateRangeMin" :max="dateRangeMax" scrollable
                  :title-date-format="date => this.formatDateCommon(date, {month: 'numeric', day: 'numeric'})"
                  :header-date-format="date => this.formatDateCommon(date, {year: 'numeric', month: 'numeric'})"
                  :month-format="date => this.formatDateCommon(date, {month: 'numeric'})"
                  :first-day-of-week="firstDayOfWeek()"
                  :locale="locale">
                  <v-spacer></v-spacer>
                  <v-btn small outline flat
                    type="button"
                    @click="showDatepickerEnd = false">{{$t("btn.cancel")}}</v-btn>
                  <v-btn small outline flat
                    type="button"
                    @click="$refs.datePickerEndDialog.save(dateEnd)">{{$t("btn.ok")}}</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs4>

              <v-select
                :label="$t('chart.label-time')"
                v-model="timeEnd"
                :items="selectTimes"
                required
                auto
                :rules="startTimeEndTimeRules"
              ></v-select>

            </v-flex>
          </v-layout>

          <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                flat
                @click.native="showDialog=false"
              >
                {{$t('btn.cancel')}}
              </v-btn>

              <v-btn
                color="primary"
                class="ml-4"
                @click.prevent="createDownloadZip"
                :disabled="btnDisable||!validated"
              >
                <v-icon class="caption">cloud_download</v-icon> &nbsp;
                {{$t('csv-download.button-download')}}
              </v-btn>
          </v-layout>
          <!-- errors -->
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showErrorMessage" persistent max-width="400">
      <v-card>
        <v-card-text v-html="errorMessage"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat="flat" v-on:click="showErrorMessage=false">{{$t('btn.ok')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import utils from '@/utils/utils.js'
import config from '@/config.js'
import http from '@/utils/http.js'
import axios from 'axios'

export default {
  components: {
  },
  props: {
    locale: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: ''
    },
    earliestLogInfo: Object,
    filtrationSystemProp: Object,
    filterProp: Object
  },
  data () {
    return {
      filter: null,
      filtrationSystem: null,
      dateRangeMin: null,
      dateRangeMax: null,
      dateStart: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      showDatepickerStart: null,
      showDatepickerEnd: null,
      selectTimes: [],
      userRole: this.$store.getters.user.roles[0]['name'],
      viewerRoleName: config.role.Viewer,
      validated: false,
      errorMessage: '',
      showErrorMessage: false,
      showDialog: false,
      btnDisable: false,
      startDateEndDateRules: [
        (v) => this.startEndCorrelationValidationCase(this.dateStartUnix, this.dateEndUnix) || this.$t('csv-download.invalid-start-end-datetime')
      ],
      startTimeEndTimeRules: [
        (v) => this.startEndCorrelationValidationCase(this.dateStartUnix, this.dateEndUnix) || ''
      ]
    }
  },
  computed: {
    /**
     * 開始日時のUNIXタイムスタンプ
     */
    dateStartUnix: {
      get: function () {
        return utils.getDateTimeUnixTimestamp(this.dateStart, this.timeStart)
      }
    },
    /**
     * 終了日時のUNIXタイムスタンプ
     */
    dateEndUnix: {
      get: function () {
        return utils.getDateTimeUnixTimestamp(this.dateEnd, this.timeEnd)
      }
    },
    /**
     * 日フォーマット
     */
    formatDateStart: {
      get: function () {
        return this.dateStart == null
          ? null : this.formatDateCommon(this.dateStart, {year: 'numeric', month: 'numeric', day: 'numeric'})
      },
      set: function (dateStart) {
        this.dateStart = dateStart
      }
    },
    /**
     * 日フォーマット
     */
    formatDateEnd: {
      get: function () {
        return this.dateEnd == null
          ? null : this.formatDateCommon(this.dateEnd, {year: 'numeric', month: 'numeric', day: 'numeric'})
      },
      set: function (dateEnd) {
        this.dateEnd = dateEnd
      }
    },
    forbiddenBrowser: {
      get: function () {
        return false
      }
    }
  },
  watch: {
    filterProp () {
      this.filter = this.filterProp
    },
    filtrationSystemProp () {
      this.filtrationSystem = this.filtrationSystemProp
    },
    dateStartUnix () {
      this.$refs.csvDownloadForm.validate()
    },
    dateEndUnix () {
      this.$refs.csvDownloadForm.validate()
    }
  },
  beforeMount () {
    // 時刻セレクトボックス生成
    const minutesArr = [0, 15, 30, 45]
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of minutesArr) {
        const timeInnerStr = ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2)
        const timeStr = this.formatDateCommon(new Date(1970, 1, 1, hour, minute), {hour: 'numeric', minute: 'numeric'})
        this.selectTimes.push({text: timeStr, value: timeInnerStr})
      }
    }
  },
  methods: {
    /**
     * ダウンロードダイアログを表示する
     */
    startDialog () {
      this.dateRangeMax = utils.formatDateForDatePickerAndTime(new Date().getTime(), this.locale, this.timezone, 'YYYY-MM-DD', true)
      this.dateRangeMin = utils.formatDateForDatePickerAndTime(this.earliestLogInfo.earliestTimestamp, this.locale, this.timezone, 'YYYY-MM-DD')

      let datetimeEnd = Math.floor(new Date().getTime() / 1000)
      datetimeEnd = datetimeEnd - (datetimeEnd % (15 * 60))
      let datetimeStart = this.earliestLogInfo.earliestTimestamp
      datetimeStart = datetimeStart - (datetimeStart % (15 * 60))

      this.dateEnd = utils.formatDateForDatePickerAndTime(datetimeEnd, this.locale, this.timezone, 'YYYY-MM-DD')
      this.dateStart = utils.formatDateForDatePickerAndTime(datetimeStart, this.locale, this.timezone, 'YYYY-MM-DD')

      this.timeEnd = utils.formatDateForDatePickerAndTime(datetimeEnd, this.locale, this.timezone, 'HH:mm')
      this.timeStart = utils.formatDateForDatePickerAndTime(datetimeStart, this.locale, this.timezone, 'HH:mm')

      this.showDialog = true
    },
    /**
     * エラーメッセージをダウンロードボタンの下に5秒表示する
     */
    showError (error) {
      this.showErrorMessage = true
      this.errorMessage = error
    },
    /**
     * ZIPファイル(中にCSVファイルが入っている)を作成し、作成に成功したらダウンロード処理を実行する
     * データがなくZIPファイルが作成されなかった場合はエラーメッセージを表示する
     */
    createDownloadZip () {
      let params = this.setParams()
      // console.log(params)
      this.showDialog = false
      http.request('post', '/service2/dashboard/api/FiltrationSystemLogs/getSensorLogCsvDownloadUrl', params)
        .then(response => {
          const data = response.data
          if (data.result === -500) {
            this.showError(this.$t('csv-download.failed-create-zip-file-fatal'))
          } else if (data.result === -501) {
            this.showError(this.$t('csv-download.failed-create-zip-file-busy'))
          } else if (data.downloadShortUrl !== undefined) {
            this.downloadRequest(data.downloadShortUrl, params.zipFileName)
          } else {
            this.showError(this.$t('csv-download.failed-download-no-data'))
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          this.showError(this.$t('csv-download.failed-create-zip-file-fatal'))
        })
      return
    },
    /**
     * ZIPダウンロードリクエストを発行する
     */
    async downloadRequest (downloadShortUrl, downloadFileName) {
      const downloadUrl = downloadShortUrl
      if (utils.iOS() && utils.safari()) {
        // #23338
        this.letBrowserToSave(null, downloadUrl, downloadFileName)
      } else {
        window._httpGrovalHookEnabled = false
        const getConfig = {
          responseType: 'blob'
        }
        const zipRes = await axios.get(downloadUrl, getConfig)
        let blob = new Blob([zipRes.data])
        this.letBrowserToSave(blob, null, downloadFileName)
      }
    },
    /**
     * blobファイルを保存する
     * iOS safariについては、ダウンロードリンクをクリックさせる
     * @param remoteTargetUrl
     *  null でない場合は brob を使わず、ブラウザにリモートからダウンロードさせる。
     *  IE11 は未実装。
     */
    letBrowserToSave (blob, remoteTargetUrl, downloadFileName) {
      // IE11はwindow.navigator.msSaveOrOpenBlobを利用してBlobをダウンロードさせる
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, downloadFileName)
      } else {
        const link = document.createElement('a')
        if (remoteTargetUrl) {
          console.log('let browser download ' + downloadFileName)
          link.href = remoteTargetUrl
        } else {
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', downloadFileName)
        }
        document.body.appendChild(link)
        console.log('link.click()')
        link.click()
      }
    },
    // ZIPダウンロード用パラメータを設定する
    // TODO サービス追加時にはこのメソッドと言語ファイルに処理、設定を追加すること
    setParams () {
      let params = {}
      let settingParams = this.$store.getters.settingParams
      if (settingParams === null) {
        settingParams = {}
      }
      // zipファイル内のCSVファイル名のプレフィックス
      const zipNamePrefix = this.filtrationSystem.filtrationSystemId + '_' + this.sanitizeBaseNameForFileName(this.filtrationSystem.filtrationSystemName)
      // zipファイル名の日付(yyyyMMddHHmm)
      const zipNameFrom = moment.unix(this.dateStartUnix).tz(this.timezone).format('YYYYMMDDHHmm')
      const zipNameTo = moment.unix(this.dateEndUnix).tz(this.timezone).format('YYYYMMDDHHmm')
      // zipファイル名
      const zipBaseName = zipNamePrefix + '_' + zipNameFrom + '_' + zipNameTo
      // zipファイル名
      const zipFileName = this.omitLongerZipFileBaseName(zipBaseName) + '.zip'

      params = {
        filtrationSystemId: this.filtrationSystem.filtrationSystemId, // 浄水器システムID
        from: this.dateStartUnix, // 開始日時
        to: this.dateEndUnix, // 終了日時
        timezone: this.timezone, // タイムゾーン
        zipFileName: zipFileName, // zipファイル名
        units: {
          flow: settingParams.unit || 'liter',
          temperature: settingParams.temperatureUnit || '°C',
          pressure: settingParams.pressureUnit || 'MPa'
        }
      }
      return params
    },
    /**
     * ファイル名に利用するためにzipファイルのbasenameのサニタイズをする
     * サニタイズ仕様:
     * 絵文字は''に置換する
     * ファイル名に利用できない文字が含まれていたら全角文字に変換する
     */
    sanitizeBaseNameForFileName (baseName) {
      let sanitizedBaseName = baseName.replace(/([\uD83C-\uD83F][\uDC00-\uDFFF])/g, '')
      return sanitizedBaseName.replace(/\\/g, '￥').replace(/\//g, '／')
        .replace(/:/g, '：').replace(/\?/g, '？').replace(/"/, '”')
        .replace(/</, '＜').replace(/>/g, '＞').replace(/\|/, '｜')
    },
    /**
     * ファイ名の文字列を切り詰める
     */
    omitLongerZipFileBaseName (zipBaseName) {
      const strLen = 125
      const { StringDecoder } = require('string_decoder')
      const decoder = new StringDecoder('utf8')
      if (Buffer.byteLength(zipBaseName, 'utf8') >= strLen) {
        let buf = new Buffer(zipBaseName)
        return decoder.write(buf.slice(0, strLen))
      } else {
        return zipBaseName
      }
    },
    /**
     * JSONオブジェクトのディープコピー
     */
    deepCopyJson (o) {
      let cache = []
      let copyO = JSON.parse(JSON.stringify(o, function (key, value) {
        if (typeof value === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // Duplicate reference found
            try {
              // If this value does not reference a parent it can be deduped
              return JSON.parse(JSON.stringify(value))
            } catch (error) {
              // discard key if value cannot be deduped
              return
            }
          }
          // Store value in our collection
          cache.push(value)
        }
        return value
      }))
      cache = null
      return copyO
    },
    /**
     * 日付をフォーマットする
     */
    formatDateCommon (date, dateOptions) {
      dateOptions.timezone = this.timezone
      return utils.dateFormatter(this.locale, moment(date).unix() * 1000, dateOptions)
    },
    /**
     * カレンダーの週の開始曜日を設定する
     */
    firstDayOfWeek () {
      return utils.firstDayOfWeek(this.locale)
    },
    /**
     * 開始日時と終了日時の相関チェック
     * 開始日時 <= 終了日時であること
     * 開始日時 > 終了日時の場合はエラーメッセージを出すとともにダウンロードボタンを無効にする
     */
    startEndCorrelationValidationCase (dateStartUnix, dateEndUnix) {
      return dateStartUnix <= dateEndUnix
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>

#maps {
  -webkit-transition: width 300ms ease, height 300ms ease;
  transition: width 300ms ease, height 300ms ease;
}

#customer-add-btn {
  border-radius: 0px;
}

 </style>



// WEBPACK FOOTER //
// CsvDownloadDialog.vue?7f9aeb36